export enum AnsweringAction {
  NONE = 0,
  REPLYING = 1,
  EDITING = 2,
  DELETING = 3
}